import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration (same as admin dashboard)
const firebaseConfig = {
  apiKey: "AIzaSyBL9d4ke59xS2xoD6hfSGhb8Hjd6HZjH88",
  authDomain: "v-labs-b023b.firebaseapp.com",
  projectId: "v-labs-b023b",
  storageBucket: "v-labs-b023b.firebasestorage.app",
  messagingSenderId: "94979382998",
  appId: "1:94979382998:web:3b7d2bf80a3330ca6295e4",
  measurementId: "G-FMLQJY29LQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;